import React from "react";

import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { CollapsibleContent, CollapsibleTitle } from "../../Collapsible";
import CollapsibleGroup from "../../CollapsibleGroup";
import Image from "../../Image";
import Markdown from "../../Markdown";
import HeadlineItem from "../ContentElement/HeadlineItem";
import { SideNavContainer } from "../SideNavContainer";
import useSideNavStore from "../SideNavContainer/store";

const OuterContainer = styled.div`
    ${({ theme }) => css`
        ${theme.paddings.containerOuter.left}
        ${theme.paddings.containerOuter.right}
    `}
`;

const InnerContainer = styled.div`
    ${({ theme }) => css`
        ${theme.paddings.containerInner.left}
        ${theme.paddings.containerInner.right}
    `}
`;

const Text = styled(Markdown)`
    ${({ theme }) => css`
        color: ${theme.colors.blue.toString()};

        a {
            color: ${theme.colors.red.toString()};
            text-decoration: underline;
        }
    `};
`;

const ElementCollapsibleItemsTextItemsMarkdown = ({ text }) => (
    <Text>{text}</Text>
);

const Components = {
    CMSImage: Image,
    ElementCollapsibleItemsTextItemsMarkdown,
};

const Collapsible = ({ name, headline_type, items, container }) => {
    const [paddingLeft] = useSideNavStore((state) => [state.paddingLeft]);
    const component = (
        <CollapsibleGroup>
            <SideNavContainer paddingLeft={paddingLeft}>
                {name && (
                    <HeadlineItem headline={headline_type || 2}>
                        {name}
                    </HeadlineItem>
                )}
                {items.map((item, index) => {
                    const elementName = item.name.replace("", "-");

                    return (
                        <CollapsibleGroup.Item
                            key={index}
                            name={`item-${elementName}`}
                            role="group"
                        >
                            <CollapsibleTitle>{item.name}</CollapsibleTitle>
                            <CollapsibleContent>
                                {item.textItems.map(
                                    ({ __typename, ...textItem }, i) => {
                                        const Component =
                                            Components[__typename];

                                        return (
                                            <Component key={i} {...textItem} />
                                        );
                                    }
                                )}
                            </CollapsibleContent>
                        </CollapsibleGroup.Item>
                    );
                })}
            </SideNavContainer>
        </CollapsibleGroup>
    );

    if (container === "no") {
        return component;
    }

    return (
        <OuterContainer>
            {container === "small" ? (
                <InnerContainer>{component}</InnerContainer>
            ) : (
                component
            )}
        </OuterContainer>
    );
};

export default Collapsible;
